var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-automator-pane"},[_c('AutomatorControls'),(_vm.isTextAutomator)?_c('AutomatorTextEditor',{attrs:{"current-script-id":_vm.currentScriptID}}):_vm._e(),(!_vm.isTextAutomator)?_c('AutomatorBlockEditor'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }